import { render, staticRenderFns } from "./W8BEN.vue?vue&type=template&id=49cfb4b1&scoped=true&"
import script from "./W8BEN.vue?vue&type=script&lang=ts&"
export * from "./W8BEN.vue?vue&type=script&lang=ts&"
import style0 from "./W8BEN.vue?vue&type=style&index=0&id=49cfb4b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cfb4b1",
  null
  
)

export default component.exports